// extracted by mini-css-extract-plugin
module.exports = {"drawerNavBarMainContainer":"az_Xsb","leftControls":"az_Ysb","closeIcon":"az_Zsb","backButton":"az__sb","backIcon":"az_atb"};